import React from 'react';
import { useTheme } from '@mui/material';

interface LoginFormProps {
  children: React.ReactNode;
  onSubmit: (e: React.FormEvent) => void;
}

export const LoginForm: React.FC<LoginFormProps> = ({ children, onSubmit }) => {
  const theme = useTheme();
  return (
    <div style={{
      minHeight: '100vh',
      width: '100vw',
      background: 'url(assets/logo/pexels-marek-piwnicki-3907296-18688551.jpg) center/cover no-repeat',
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
    }}>
      <div style={{
        position: 'absolute',
        inset: 0,
        background: theme.palette.mode === 'dark'
          ? 'rgba(24, 36, 72, 0.85)'
          : 'rgba(24, 36, 72, 0.75)',
        zIndex: 1,
      }} />
      <form
        style={{
          position: 'relative',
          zIndex: 2,
          background: theme.palette.background.paper,
          borderRadius: 20,
          boxShadow: '0 4px 24px 0 rgba(24, 36, 72, 0.10)',
          padding: '48px 40px 32px 40px',
          minWidth: 380,
          maxWidth: '90vw',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
        onSubmit={onSubmit}
      >
        {children}
      </form>
    </div>
  );
};